import { Controller } from "@hotwired/stimulus"

// Leave-ledger booking dialog: choosing "Auszahlung" prefills the exact open
// balance of the chosen account as a negative booking. The Urlaubsabgeltung is
// paid to the hundredth — a fraction below half a day is neither rounded nor
// dropped (BAG 9 AZR 200/17) — so the value is never rounded here either.
// A SOKA account gets no payout: SOKA-BAU pays it (BRTV § 8 Nr. 6), the dialog
// says so and the model refuses the booking.
//
// Only a value this controller filled in is ever replaced or cleared, so a
// number the admin typed survives switching the account or the reason.
export default class extends Controller {
  static targets = ["kind", "reason", "days", "payoutHint", "sokaHint"]
  static values = { payouts: Object }

  connect() {
    this.autofilled = null
    this.update()
  }

  update() {
    const payout = this.reasonTarget.value === "payout"
    const soka = this.kindTarget.value === "soka"
    const open = this.payoutsValue[this.kindTarget.value]

    this.sokaHintTarget.classList.toggle("hidden", !(payout && soka))
    this.payoutHintTarget.classList.toggle("hidden", !(payout && !soka && open))

    if (payout && !soka && open) {
      this.fill(`-${open}`)
    } else {
      this.fill("")
    }
  }

  fill(value) {
    const current = this.daysTarget.value
    if (current !== "" && current !== this.autofilled) return

    this.daysTarget.value = value
    this.autofilled = value === "" ? null : value
  }
}
